/**
 * Basic TomSelect for a one selection dropdown with visible placeholder
 *
 */
import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    closeAfterSelect: { type: Boolean, default: false },
  };

  connect() {
    // Check if TomSelect is already initialized
    if (this.element.tomselect) {
      return;
    }

    const plugins = this.element.attributes["multiple"]
      ? ["remove_button"]
      : [];
    var config = {
      plugins: plugins,
      hidePlaceholder: true,
      closeAfterSelect: this.closeAfterSelectValue,
    };

    this.tomselect = new TomSelect(this.element, config);
  }

  disconnect() {
    // Clean up TomSelect instance when controller disconnects
    if (this.tomselect) {
      try {
        this.tomselect.destroy();
      } catch (e) {
        // Ignore errors during cleanup - element may already be removed from DOM
      }
      this.tomselect = null;
    }
  }
}
